/**
 * Field  component state
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export interface IFieldState {
	value: unknown;
	initialValue: unknown;

	empty: boolean;
	touched: boolean;
	changed: boolean;
	valid: boolean;

	/** Methods */
	setValue?: (value: unknown) => void;
	clearValue?: (initial: boolean) => void;
}

export const initialFieldState = {
	empty: true,
	touched: false,
	changed: false,
	valid: true
};
